// extracted by mini-css-extract-plugin
export default {"info":"bvs3tqYSaC","h-rule":"AOPdMpfFu+","hRule":"AOPdMpfFu+"};